import { useLocation, useNavigate } from "react-router-dom";
import { TableComponent } from "V2.0/HomePages/HomeModule/CustomAPIs/components/TableComponent";
import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableCell,
  TableRow,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { Tooltip } from "antd";
import { FolderIcon, TrashIcon } from "@heroicons/react/24/outline";

function SourceIcon({ children }) {
  return (
    <div className="h-10 w-10 flex justify-center items-center">{children}</div>
  );
}

export function KnowledgebaseTable(props) {
  const { knowledgeBases, onDelete, isViewOnly } = props;
  const navigate = useNavigate();
  const location = useLocation();

  const handleRowClick = (item) => {
    navigate({pathname: `/knowledgebases/${item._id}`, search: location.search}, {
      state: { knowledgeBase: item },
    });
  };

  if (knowledgeBases.isLoading) {
    return null;
  }

  return (
    <Table>
      <TableHead>
        <TableHeader>Knowledge Base</TableHeader>
        <TableHeader>Action</TableHeader>
      </TableHead>
      <TableBody>
        {knowledgeBases.data.map((knowledgeBase, index) => {
          const { _id, label } = knowledgeBase;
          return (
            <TableRow
              key={_id}
              onClick={() => handleRowClick(knowledgeBase)}
              className="hover:bg-gray-100 hover:cursor-pointer"
            >
              <TableCell>
                <div className="flex items-start gap-x-2">
                  <div>
                    <SourceIcon>
                      <FolderIcon className="size-5"/>
                    </SourceIcon>
                  </div>
                  <div className="flex flex-col gap-y-2">
                    <p className="font-semibold text-sm/8">{label}</p>
                  </div>
                </div>
              </TableCell>
              <TableCell>
                {!isViewOnly && <div className="flex gap-x-2">
                  <Button
                    outline
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(knowledgeBase);
                    }}
                  >
                    <TrashIcon />
                  </Button>
                </div>}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
